import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { handleSubjectChange } from 'actions/template'

export default connect(
  (state) => ({
    value: state.email.subject.value,
    to: state.inbox.to.current.value,
  }),
  (dispatch) => bindActionCreators({ handleSubjectChange }, dispatch),
)(({ value, handleSubjectChange, to }) => {
  return (
    <div>
      <input
        style={{
          width: '100%',
          borderWidth: 1,
          borderStyle: 'solid',
          fontSize: 16,
        }}
        placeholder={`Subject to ${to}`}
        value={value}
        onChange={(e) => handleSubjectChange(e.target.value)}
      />
    </div>
  )
})
